import FileExplorer from 'components/global/FileExplorer/FileExplorer';
import SimpleCard from 'components/global/SimpleCard';
import PublicRoomContainer from 'components/views/PublicRoom/_components/PublicRoomContainer';
import { $detail, $view } from 'signals/global.signals';

const PublicRoomVault = () => (
  <PublicRoomContainer>
    <SimpleCard>
      <FileExplorer
        folders={$detail.value.folders || []}
        isLoading={$view.value.isLoading}
        mode="view"
        onClickViewDocument={(document) => {
          window.open(document.url, '_blank');
        }}
      />
    </SimpleCard>
  </PublicRoomContainer>
);

export default PublicRoomVault;
